import React, {useState, useEffect, useRef} from 'react';
import {NotificationManager} from "react-notifications";
import * as Apis from "Api";
import BoxplotChart from "../../../../Components/BoxplotChart";
import ReattemptQuizModal from "../ReattemptQuizModal";
import {startMainAndSubActivities} from "../../../../services/AuditDataLogger";
import QueryString from "query-string";
import {useNavigate} from "react-router-dom";

function VideoLectureScore({attemptInfo}) {
    const navigate = useNavigate();
    const [questionList, setQuestionList] = useState([]);
    const [isEmptyTruth, setIsEmptyTruth] = useState(true);
    const [reattemptQuizPercent, setReattemptQuizPercent] = useState(null);

    useEffect(() => {
        if (attemptInfo.test_sets.modalities.modality_type === 'video_lecture') {
            Apis.getAttemptQuizAnswer(attemptInfo.id, attemptInfo.current_test_case_id, false).then((quizAnswer) => {
                setQuestionList(quizAnswer);
                let emptyTruth;
                if(Array.isArray(quizAnswer)) {
                    emptyTruth = quizAnswer.some(v => !v.truthOptionId || v.truthOptionId.length === 0);
                } else {
                    delete quizAnswer?.isFinished;
                    emptyTruth = !Object.keys(quizAnswer).length;
                }
                setIsEmptyTruth(emptyTruth);
            }).catch((error) => {
                NotificationManager.error(error.response ? error.response.data.error.message : error.message);
            });
        }
        if ( attemptInfo.complete && attemptInfo.scores.length > 0 ) {
            const percent = attemptInfo.scores[0]?.score === undefined ? 0 : attemptInfo.scores[0].score;
            const param = QueryString.parse(window.location.search);
            if (param && param.from === 'test' && percent < 75) {
                setReattemptQuizPercent(percent);
            }
        }
    }, []);

    const isAnswerCorrect = (truthOptionId, answerOptionId) => {
        const truthArray = Array.isArray(truthOptionId) ? truthOptionId : [truthOptionId];
        const answerArray = Array.isArray(answerOptionId) ? answerOptionId : [answerOptionId];
        return answerArray.every(answer => truthArray.includes(answer));
    }

    const renderPercent = () => {
        if (isEmptyTruth) return null;
        const percent = attemptInfo.scores[0]?.score === undefined ? 0 : attemptInfo.scores[0].score;
        return (
            <div className={'col-md-6 score-data-container'}>
                <div className={'quiz-score-data'}>
                    <div className="circle-progress">
                        <svg viewBox="0 0 36 36">
                            <path className="circle-bg" d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"/>
                            <path className="circle" stroke-dasharray={`${percent}, 100`} d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"/>
                        </svg>
                    </div>
                    <div className={'quiz-progress-info'}>
                        <span className={'text-white fs-19'}>{percent} %</span>
                        <span className={'text-white fs-23 fw-bold'}>Correct</span>
                    </div>
                </div>
                <div className={'score-chart-container mt-4'}>
                    <BoxplotChart
                        title={'Results compared to'}
                        score_type={
                            ['video_lecture', 'interactive_video'].indexOf(attemptInfo.test_sets.modalities.modality_type) !== -1 ? 'Video Lecture Result' : 'Presentations Result'
                        }
                        showUserSelect={true}
                        attempt_id={attemptInfo.id}
                        value={percent}
                    />
                </div>
            </div>
        )
    }

    const renderAnswers = () => {
        if (!Array.isArray(questionList) || questionList.length === 0) return null;
        return (
            <div className={'d-flex flex-column bg-gray p-4'} style={{minHeight: 423}}>
                <span className={'fs-19 pb-3 border-bottom'}>Answer</span>
                {
                    questionList.map((v) => (
                        <div key={v.id} className={'d-flex flex-column fs-15 border-bottom py-3'}>
                            <div dangerouslySetInnerHTML={{__html: v.question || v.name}}/>
                            <span className={'mt-1 ps-2'}>{isAnswerCorrect(v.truthOptionId, v.answerOptionId) ? 'True' : 'False'}</span>
                        </div>
                    ))
                }
                <span></span>
            </div>
        )
    }

    const onRestartTest = () => {
        startMainAndSubActivities('Redo Test');
        Apis.attemptsStart(attemptInfo.test_set_id, undefined).then(resp => {
            let path = '/video-view/' + resp.test_set_id + '/' + resp.id + '/' + resp.current_test_case_id;
            navigate(path, { replace: true });
        });
    }

    if (isEmptyTruth) return null;
    return (
        <div className={'row'}>
            {renderPercent()}
            <div className={'col-md-6'}>
                {/*{renderAnswers()}*/}
            </div>

            <ReattemptQuizModal
                open={reattemptQuizPercent !== null}
                score={reattemptQuizPercent}
                onClose={() => setReattemptQuizPercent(null)}
                onReattempt={() => onRestartTest()}
            />
        </div>
    )
}

export default VideoLectureScore;
